import React from "react"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"
import { Element } from "react-scroll"
import WOW from "react-wow"

import AboutSlider from "./AboutSlider"

import * as S from "./styled"

const About = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          topBg: file(relativePath: { eq: "backgrounds/fluid-top-1.png" }) {
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          botBg: file(relativePath: { eq: "backgrounds/fluid-bot-1.png" }) {
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          machineHero: file(relativePath: { eq: "trumps/machine-hero.png" }) {
            childImageSharp {
              fluid(maxWidth: 700) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          content: allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(section_sobre)/" } }
          ) {
            nodes {
              frontmatter {
                title
                description
                servicos {
                  title
                  description
                  icon
                }
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <S.AboutWrapper>
            <S.CurveTop fluid={data.topBg.childImageSharp.fluid} />
            <S.AboutContent>
              <Container>
                <Row>
                  <Col lg={5}>
                    <Element name="caption-about">
                      <S.AboutCaption>
                        <WOW animation="fadeInUp">
                          <S.AboutTitle>
                            {data.content.nodes[0].frontmatter.title}
                          </S.AboutTitle>
                          <div>
                            <S.AboutHero
                              isMobile={true}
                              fluid={data.machineHero.childImageSharp.fluid}
                            ></S.AboutHero>
                          </div>
                          <S.AboutDesc>
                            {data.content.nodes[0].frontmatter.description}
                          </S.AboutDesc>
                        </WOW>
                      </S.AboutCaption>
                    </Element>
                  </Col>
                  <WOW animation="fadeIn">
                    <Col lg={7}>
                      <S.AboutHero
                        fluid={data.machineHero.childImageSharp.fluid}
                      ></S.AboutHero>
                    </Col>
                  </WOW>
                </Row>
                <AboutSlider
                  items={data.content.nodes[0].frontmatter.servicos}
                />
              </Container>
            </S.AboutContent>
            <S.CurveBottom fluid={data.botBg.childImageSharp.fluid} />
          </S.AboutWrapper>
        )
      }}
    />
  )
}

export default About
